import { Button, DatePicker, Drawer, Form, Input, InputNumber } from 'antd';
import React, { useState } from 'react';
import { App } from 'antd';
import { getHttpErrorMessage } from 'utils/http';
import { captureException } from 'utils/errors';

function AddCallDrawer({ open, onClose, onSubmit }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      const payload = {
        outcome: values.outcome || undefined,
        summary: values.summary || '',
        duration_minutes: values.duration_minutes || undefined,
        follow_up_at: values.follow_up_at ? values.follow_up_at.toISOString() : undefined,
      };
      onSubmit(payload)
        .then(() => form.resetFields())
        .catch((e) => {
          captureException(e);
          message.error(getHttpErrorMessage(e) || 'Failed to log call');
        })
        .finally(() => setLoading(false));
    }).catch(() => {});
  };

  return (
    <Drawer
      title="Log Call"
      width={400}
      open={open}
      onClose={handleClose}
      footer={(
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={handleSubmit}>
            Save
          </Button>
        </div>
      )}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="outcome" label="Outcome">
          <Input placeholder="e.g. Completed, No answer" />
        </Form.Item>
        <Form.Item name="summary" label="Summary" rules={[{ required: false }]}>
          <Input.TextArea placeholder="Call notes..." rows={4} />
        </Form.Item>
        <Form.Item name="duration_minutes" label="Duration (minutes)">
          <InputNumber min={1} placeholder="Minutes" style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="follow_up_at" label="Follow-up">
          <DatePicker showTime style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export default AddCallDrawer;
